import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Founder UAT B1 — backend timestamps sometimes arrive as tz-naive ISO
// strings (legacy BSON datetimes). They are ALWAYS UTC: normalize before
// handing to Date so they render correctly in the viewer's timezone.
export const parseApiDate = (iso) => {
  if (!iso) return null;
  if (iso instanceof Date) return iso;
  let s = String(iso);
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s) && !/(Z|[+-]\d{2}:?\d{2})$/.test(s)) {
    s += 'Z';
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
};
